import { BrowserProductQueryQuery } from "@generated/graphql"
import { Person } from "@faststore/sdk/dist/session"
import { getCookie } from "./cookie"
import { getDeliveryType } from "./getDeliveryType"
import { getCategorie, getItemSizeFromProperties, getProperty } from "./getProductDetailsInfo"

export const formatAnalyticsData = (
  product: BrowserProductQueryQuery['product'],
  selectedSKU: BrowserProductQueryQuery['product'],
  slasSnapshot: ShippingSimulation[],
  person: Person | null,
) => {
  if (!product || !selectedSKU) {
    return
  }

  const productIdMatch = product?.slug?.match(/\b[a-z]{2}\d{8}\b/)

  const categories = getCategorie(
    product?.breadcrumbList?.itemListElement ?? [],
    product?.name
  )

  const productSize = getItemSizeFromProperties(
    product?.isVariantOf?.additionalProperty,
    selectedSKU?.additionalProperty
  )

  const hasStock = product?.offers?.offers?.[0]?.availability === 'https://schema.org/InStock'

  const hasPersonalization: boolean = !!product?.productClusters?.some(
    (cluster) => cluster.name?.toLowerCase().includes('personaliz')
  )

  return {
    sku_id: selectedSKU?.sku,
    item_id: productIdMatch?.[0]?.toUpperCase() ?? product?.gtin,
    item_name: product?.name,
    item_price: product?.offers?.offers?.[0]?.price ?? 0,
    item_type: product?.name?.match(/^\p{L}+/u)?.[0] ?? "",
    item_weight: product?.name?.match(/(\d+)\s*k/i)?.[0] ?? "",
    item_brand: product?.brand?.name,
    item_collection: getProperty(product, 'coleção'),
    item_stone: getProperty(product, 'pedras'),
    item_material: getProperty(product, 'material'),
    item_audience: getProperty(product, 'sugestão'),
    item_reference: selectedSKU?.gtin,
    item_category: categories[0] ?? "",
    item_category2: categories[1] ?? "",
    item_category3: categories[2] ?? "",
    item_category4: categories[3] ?? "",
    item_category5: categories[4] ?? "",
    item_category6: categories[5] ?? "",
    item_currency: 'BRL',
    item_size: productSize ?? "",
    item_out_stock: hasStock ? false : true,
    is_personalizable: hasPersonalization,
    delivery_type: hasStock ? getDeliveryType(slasSnapshot) : "indisponível",
    quantity: 1,
    discount: product?.offers?.offers?.[0]?.listPrice - product?.offers?.offers?.[0]?.price,
    user_logged: !!person?.id,
    user_id: person?.id ?? null,
    currency: 'BRL',
    value: product?.offers?.offers?.[0]?.price,
    uuid: getCookie('uuid')
  }
}